import React, { Component } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import TweenLite from "gsap/umd/TweenMax";

import { selectFilterItems, selectFilters, selectMunicipalities } from "./../../selectors.js";

// Components
import "./style.css";
import FilterOptionItem from "./../../components/FilterOptionItem";
import LoadingBox from "./../../components/LoadingBox";

let hover;

class FilterOptions extends Component {
    constructor() {
        super();

        this.state = {
            menuOpen: false,
            epokeOpen: false,
            fylkeOpen: false,
            kommuneOpen: false,
            hovedmaterialeOpen: false,
            vernegruppeOpen: false,
        };

        this.displayBurgerMenu = this.displayBurgerMenu.bind(this);
        this.removeInlineStyle = this.removeInlineStyle.bind(this);
        this.openFilter = this.openFilter.bind(this);
    }

    componentDidMount() {
        this.removeInlineStyle();
    }

    displayBurgerMenu() {
        // Når i mobilvisning
        const { menuOpen } = this.state;
        const options = menuOpen ? { right: "-80%" } : { right: "0%" };
        const darkLayerOptions = menuOpen
            ? { right: "-100%", opacity: "0" }
            : { right: "0%", opacity: "1" };

        TweenLite.to(this.filterOptions, 0.6, options);
        TweenLite.to(this.darkBackLayer, 0.6, darkLayerOptions);

        if (menuOpen) {
            TweenLite.to(this.darkBackLayer, 0.6, {
                opacity: "0",
                onComplete: () => {
                    TweenLite.set(this.darkBackLayer, { display: "none" });
                },
            });
        } else {
            TweenLite.set(this.darkBackLayer, { display: "block" });
            TweenLite.to(this.darkBackLayer, 0.6, { opacity: "1" });
        }

        this.setState({ menuOpen: !menuOpen });
    }

    mobileMenuOpenClose(type) {
        const w = window.innerWidth;
        let openState = this.state[type];

        if (w > 767) return null;

        if (openState) {
            this[type].classList.remove("open-filter");
            // TweenLite.set(this[type], {display: 'none'})
            this.setState({ [type]: false });
        } else {
            this[type].classList.add("open-filter");
            this.setState({ [type]: true });
        }
    }

    printFilterItems(items, type) {
        const { filterItems } = this.props;

        if (!filterItems) return null;

        return items.map((data) => {
            // Checking if current has allready been choosen
            const exists = filterItems.some((item) => item.key === data.key);
            return (
                <FilterOptionItem
                    key={data.key}
                    exists={exists}
                    type={type}
                    data={data}
                    select={(value, key, selected, type, radio) =>
                        this.props.select(value, key, selected, type, radio)
                    }
                />
            ); // props.select goes to Search component
        });
    }

    removeInlineStyle() {
        window.addEventListener("resize", resizeThrottler, false);
        const _this = this;

        var resizeTimeout;
        // Trottler to prevent from running to often
        function resizeThrottler() {
            if (!resizeTimeout) {
                resizeTimeout = setTimeout(function () {
                    resizeTimeout = null;
                    actualResizeHandler();
                }, 66);
            }
        }

        function actualResizeHandler() {
            if (window.innerWidth > 767 && _this !== null) {
                _this.epokeOpen &&
                    _this.epokeOpen.classList.remove("open-filter");
                _this.fylkeOpen &&
                    _this.fylkeOpen.classList.remove("open-filter");
                _this.kommuneOpen &&
                    _this.kommuneOpen.classList.remove("open-filter");
                _this.hovedmaterialeOpen &&
                    _this.hovedmaterialeOpen.classList.remove("open-filter");
                _this.vernegruppeOpen &&
                    _this.vernegruppeOpen.classList.remove("open-filter");
            }
        }
    }

    openFilter(type) {
        clearTimeout(hover);

        hover = setTimeout(() => {
            this[type].classList.add("open-filter");
        }, 100);
    }

    closeFilter(type) {
        clearTimeout(hover);
        this[type].classList.remove("open-filter");
    }

    render() {
        const { filters, municipalities } = this.props;

        return (
            <div className="filter-options">
                <div
                    id="darkBackLayer"
                    onClick={this.displayBurgerMenu}
                    ref={(comp) => {
                        this.darkBackLayer = comp;
                    }}
                ></div>
                <div className="filter-option-wrapper">
                    <div className="filter-burger-menu">
                        <button
                            className="filter-burger-menu__button button button--gray button--medium"
                            onClick={this.displayBurgerMenu}
                        >
                            Filter{" "}
                            <i className="filter-burger-menu__close-icon hamburger"></i>
                        </button>
                    </div>
                    <div
                        className="filter-option-inner"
                        ref={(comp) => {
                            this.filterOptions = comp;
                        }}
                    >
                        <div
                            className="filter-option-parent"
                            tabIndex="0"
                            ref={(c) => {
                                this.epokeOpen = c;
                            }}
                            onMouseOver={() => this.openFilter("epokeOpen")}
                            onMouseLeave={() => this.closeFilter("epokeOpen")}
                        >
                            <span
                                className="filter-option-parent__title"
                                onClick={() =>
                                    this.mobileMenuOpenClose("epokeOpen")
                                }
                            >
                                Epoke
                            </span>
                            <div className="filter-options-child-wrapper">
                                <div className="container filter-option-child">
                                    {filters === false ? (
                                        <p>
                                            Det oppstod en feil. Prøv å laste
                                            siden på nytt.
                                        </p>
                                    ) : filters ? (
                                        this.printFilterItems(
                                            filters.eras,
                                            "Era"
                                        )
                                    ) : (
                                        <LoadingBox text="Laster valgene dine..." />
                                    )}
                                </div>
                            </div>
                        </div>

                        <div
                            className="filter-option-parent"
                            tabIndex="0"
                            ref={(c) => {
                                this.fylkeOpen = c;
                            }}
                            onMouseOver={() => this.openFilter("fylkeOpen")}
                            onMouseLeave={() => this.closeFilter("fylkeOpen")}
                        >
                            <span
                                className="filter-option-parent__title"
                                onClick={() =>
                                    this.mobileMenuOpenClose("fylkeOpen")
                                }
                            >
                                Fylke
                            </span>
                            <div className="filter-options-child-wrapper">
                                <div className="container filter-option-child">
                                    {filters === false ? (
                                        <p>
                                            Det oppstod en feil. Prøv å laste
                                            siden på nytt.
                                        </p>
                                    ) : filters ? (
                                        this.printFilterItems(
                                            filters.countyNames,
                                            "County"
                                        )
                                    ) : (
                                        <LoadingBox text="Laster valgene dine..." />
                                    )}
                                </div>
                            </div>
                        </div>

                        {municipalities && municipalities.length > 0 && (
                            <div
                                className="filter-option-parent"
                                tabIndex="0"
                                ref={(c) => {
                                    this.kommuneOpen = c;
                                }}
                                onMouseOver={() => this.openFilter("kommuneOpen")}
                                onMouseLeave={() => this.closeFilter("kommuneOpen")}
                            >
                                <span
                                    className="filter-option-parent__title"
                                    onClick={() =>
                                        this.mobileMenuOpenClose("kommuneOpen")
                                    }
                                >
                                    Kommune
                                </span>
                                <div className="filter-options-child-wrapper">
                                    <div className="container filter-option-child">
                                        {this.printFilterItems(
                                            municipalities,
                                            "Municipality"
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}

                        <div
                            className="filter-option-parent"
                            tabIndex="0"
                            ref={(c) => {
                                this.hovedmaterialeOpen = c;
                            }}
                            onMouseOver={() =>
                                this.openFilter("hovedmaterialeOpen")
                            }
                            onMouseLeave={() =>
                                this.closeFilter("hovedmaterialeOpen")
                            }
                        >
                            <span
                                className="filter-option-parent__title"
                                onClick={() =>
                                    this.mobileMenuOpenClose(
                                        "hovedmaterialeOpen"
                                    )
                                }
                            >
                                Hovedmateriale
                            </span>
                            <div className="filter-options-child-wrapper">
                                <div className="container filter-option-child">
                                    {filters === false ? (
                                        <p>
                                            Det oppstod en feil. Prøv å laste
                                            siden på nytt.
                                        </p>
                                    ) : filters ? (
                                        this.printFilterItems(
                                            filters.constructionMaterials,
                                            "Construction"
                                        )
                                    ) : (
                                        <LoadingBox text="Laster valgene dine..." />
                                    )}
                                </div>
                            </div>
                        </div>

                        <div
                            className="filter-option-parent"
                            tabIndex="0"
                            ref={(c) => {
                                this.vernegruppeOpen = c;
                            }}
                            onMouseOver={() =>
                                this.openFilter("vernegruppeOpen")
                            }
                            onMouseLeave={() =>
                                this.closeFilter("vernegruppeOpen")
                            }
                        >
                            <span
                                className="filter-option-parent__title"
                                onClick={() =>
                                    this.mobileMenuOpenClose("vernegruppeOpen")
                                }
                            >
                                Vernegruppe
                            </span>
                            <div className="filter-options-child-wrapper">
                                <div className="container filter-option-child">
                                    {filters === false ? (
                                        <p>
                                            Det oppstod en feil. Prøv å laste
                                            siden på nytt.
                                        </p>
                                    ) : filters ? (
                                        this.printFilterItems(
                                            filters.protectionStatus,
                                            "ProtectionStatus"
                                        )
                                    ) : (
                                        <LoadingBox text="Laster valgene dine..." />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>{" "}
                    {/* END filter-option-inner */}
                </div>{" "}
                {/* END filter-option-wrapper */}
            </div>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    filterItems: selectFilterItems(),
    filters: selectFilters(),
    municipalities: selectMunicipalities(),
});

export default connect(mapStateToProps)(FilterOptions);



// WEBPACK FOOTER //
// ./src/containers/FilterOptions/index.js